import { vnApp } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp//vn_app_zone";

export class vnApp_sentinelbi extends vnApp {

	public static readonly ROLE_ADMINISTRATOR = 1;
	public static readonly ROLE_PROPERTY_MANAGER = 2;
	public static readonly ROLE_PROPERTY_USER = 3;
	public static readonly ROLE_OWNER = 4;

	public static readonly PLAN_BASIC_ID = 1;
	public static readonly PLAN_ESSENTIAL_ID = 2;
	public static readonly PLAN_ADVANCED_ID = 3;
	public static readonly PLAN_PRO_ID = 4;
	public static readonly PLAN_ENTERPRISE_ID = 5;
	public static readonly PLAN_ENTERPRISE_FREE_ID = 6;

	public static readonly STRIPE_KEY = 'pk_live_51QtwVaGBQMFmh3BoDciuLnLpLRGUkbY8MyV6d5Cl2ugVBowYPhIQApLwc7N6K19ksFaQVxmVpGrixPplGDKqXiXT00TrvUehDi';

	public static readonly RECAPTCHA_SITE_KEY = '6LePkvMrAAAAAD2MVQ_IND0YuvJRw0fx36UGLKQL';

	public static readonly BRAND_DEFAULT_ICON_PATH = "/assets/images/logos/default.png";

	protected _appInterface;

	constructor(zones:Array<vnAppZone>, appInterface) {

		super(zones);
		this._appInterface = appInterface;
	}

	get appInterface():any {
		return this._appInterface;
	}
	set appInterface(appInterface) {
		this._appInterface = appInterface;
	}

	public getIsLoggedInHttpCallUrl(){

		return '/api/access/isLoggedIn/';
	}

	public isOfRole(role: Number) {
		let show = false;

		let vnApp = this;

		if(vnApp.loggedUser.isLoggedIn){

			let roles: Array<any> = vnApp.loggedUser.user.vnAppUser.roles;
			let roleIds = [];
	
			for (let role of roles) {
				roleIds.push(role.id);
			}
			if (roleIds.indexOf(role) > -1) {
				show = true;
			}
		}

		return show;
	}

	public isDashboard() {

		return this._appInterface === 'dashboard';
	}
}



// WEBPACK FOOTER //
// ./js/components/vnApp_sentinelbi.ts